import { render, staticRenderFns } from "./ServicePredecessors.vue?vue&type=template&id=670cb272&"
import script from "./ServicePredecessors.vue?vue&type=script&lang=js&"
export * from "./ServicePredecessors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports